import { render, staticRenderFns } from "./AddPropertyVideo.vue?vue&type=template&id=8ed3f668&scoped=true&"
import script from "./AddPropertyVideo.vue?vue&type=script&lang=js&"
export * from "./AddPropertyVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed3f668",
  null
  
)

export default component.exports